<template>
    <div>
        <div class="text-center">
            <b-btn class="btn-plain" :disabled="loading" @click.prevent="getItems()">
                <i class="fas fa-folder-open mr-1"></i>{{ nombre }}
            </b-btn>
            <hr class="mt-1 mb-2" />
            <b-btn class="py-2 px-3 w-100" :disabled="loading" @click="abrirModalCrearCarpeta('crear-carpeta')">
                Crear carpeta
            </b-btn>
            <ModalCrearCarpeta name="crear-carpeta" @guardar="createCarpeta" />
            <ModalEditarCarpeta name="editar-carpeta" :carpeta="carpetaAEditar" @actualizar="editCarpeta" />
            <BorrarModalComponent name="eliminar-carpeta" title="Eliminar carpeta"
                                  borrarTitle="¿Estás seguro de que quieres eliminar esta carpeta?"
                                  confirmButton="Esta acción no se puede deshacer" @confirm="confirmarEliminarCarpeta"
            />
        </div>
        <template>
            <input
                v-model="filters.search"
                type="search"
                placeholder="🔍 Buscar carpeta"
                class="form-control mt-3 p-1"
                @input="debouncedGetCarpetas"
                :disabled="loading"
            />
            <b-list-group class="mt-2">
                <b-list-group-item
                    v-for="carpeta in carpetas.data"
                    :key="carpeta.id"
                    class="border-0 pl-0 pr-0 pb-0"
                    @mouseenter="carpeta.showIcons = true"
                    @mouseleave="carpeta.showIcons = false"
                >
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-folder-open mr-1"></i>
                            <span class="folder-name" :class="{ 'disabled-action': loading }" @click="filterCarpeta(carpeta)">{{ carpeta.nombre }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span v-if="carpeta.showIcons">
                                <i class="fas fa-edit icon mr-1" :class="{ 'disabled-action': loading }" @click="abrirModalEditarCarpeta(carpeta)"></i>
                                <i class="fas fa-trash-alt icon" :class="{ 'disabled-action': loading }" @click="modalEliminarCarpeta(carpeta)"></i>
                            </span>
                            <span v-else class="badge">{{ carpeta[totalItems] }}</span>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </template>
    </div>
</template>

<script>
    import ModalCrearCarpeta from "../../components/ModalCrearCarpeta.vue";
    import ModalEditarCarpeta from "../../components/ModalEditarCarpeta.vue";
    import BorrarModalComponent from "../../components/BorrarModalComponent.vue";

    export default {
        props: {
            loading: { type: Boolean, default: false },
            carpetas: {
                type: Object,
                default: () => ({ data: [], meta: {} }),
                require: true
            },
            nombre: {
                type: String,
                require: true
            },
            totalItems: {
                type: String,
                require: true
            }
        },
        data() {
            return {
                filters: { search: '', per_page: 9999 },
                carpetaAEditar: null,
                carpetaAEliminar: null,
            };
        },
        methods: {
            getCarpetas() {
                this.$emit('getCarpetas', this.filters.search)
            },
            getItems() {
                this.$emit('getItems', true);
            },
            filterCarpeta(carpeta) {
                this.$emit('filterCarpeta', carpeta.id);
            },
            abrirModalCrearCarpeta(nombreModal) {
                this.$modal.show(nombreModal);
            },
            createCarpeta(data){
                this.$emit("createCarpeta", data);
            },
            abrirModalEditarCarpeta(carpeta) {
                this.carpetaAEditar = carpeta;
                this.$modal.show("editar-carpeta");
            },

            editCarpeta(data){
                this.$emit("editCarpeta", data);
            },

            modalEliminarCarpeta(carpeta) {
                this.carpetaAEliminar = carpeta;
                this.$modal.show("eliminar-carpeta");
            },

            deleteCarpeta(data){
                this.$emit("deleteCarpeta", data);
            },
            confirmarEliminarCarpeta() {
                if (!this.carpetaAEliminar) return;
                this.deleteCarpeta(this.carpetaAEliminar);
            },
        },
        components: {
            ModalCrearCarpeta,
            ModalEditarCarpeta,
            BorrarModalComponent,
        },
        created() {
            this.debouncedGetCarpetas = _.debounce(this.getCarpetas, 500);
        }
    };
</script>

<style scoped>
.btn-plain {
    background: none;
    border: none;
    color: inherit;
    padding: 0;
    cursor: pointer;
    font-size: 19px;
    text-transform: none;
    transition: none;
}
.btn-plain:hover,
.btn-plain:focus {
    text-decoration: underline;
    background-color: white;
    color: #444444;
}
.btn-plain:active,
.btn-plain:focus-visible {
    background-color: white !important;
    box-shadow: none !important;
    color: #444444;
}
.badge {
    color: #fff;
    font-family: Nunito, sans-serif;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: .25px;
    background-color: #6c757d;
    border-radius: 10px;
    display: inline-block;
    font-weight: 700;
    line-height: 1;
    min-width: 10px;
    padding: 3px 7px;
    text-align: center;
    vertical-align: baseline;
    white-space: nowrap;
}
.folder-name {
    cursor: pointer;
    transition: text-decoration 0.3s ease;
}
.folder-name:hover {
    text-decoration: underline;
}
.icon {
    font-size: 15px;
    cursor: pointer;
}
.disabled-action {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
}
</style>